import {
  LabelValueForComponent,
  LabelValueForTags,
  LabelValueForText,
} from "components/ui/atoms/LabelValue";
import { Link as RouterLink } from "react-router-dom";
import MuiLink from "@mui/material/Link";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { getCommons } from "components/ui/customs/viewFields/fieldConverterHelpers";
import { flexShrink } from "@mui/system";

const OneLineDocumentFileFieldView = ({ value, my }) => {
  return (
    <Stack
      spacing={1}
      direction={"row"}
      alignItems={"center"}
      width={"calc(100% - 60px)"}
      justifyContent={"flex-end"}
      my={my || 0}
    >
      <MuiLink
        component={RouterLink}
        to={value?.file?.url}
        target="_blank"
        style={{ wordBreak: "break-word" }}
        underline="hover"
        color="inherit"
      >
        <Typography variant="body2" textAlign={"right"}>
          {value?.original_filename || ""}
        </Typography>
      </MuiLink>
      <IconButton
        LinkComponent={RouterLink}
        to={value?.file?.url}
        target="_blank"
        style={{ marginLeft: "8px" }}
      >
        <DownloadIcon />
      </IconButton>
    </Stack>
  );
};

const StadardDocumentFileFieldView = ({ field, value, formattedValue }) => {
  return (
    <LabelValueForComponent
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      labelMinWidth={60}
      isMissing={
        formattedValue === undefined ||
        formattedValue === null ||
        formattedValue.toString().trim() === ""
      }
    >
      <OneLineDocumentFileFieldView value={value} />
    </LabelValueForComponent>
  );
};

export const DocumentFileFieldView = ({
  field,
  value,
  formattedValue,
  many,
}) => {
  if (!many) {
    return (
      <StadardDocumentFileFieldView
        field={field}
        value={value}
        formattedValue={formattedValue}
      />
    );
  }
  return (
    <LabelValueForComponent
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      labelMinWidth={80}
      alignItems={"flex-start"}
      isMissing={
        value === undefined || value === null || value.toString().trim() === ""
      }
    >
      <Box
        display={"flex"}
        flexDirection="column"
        alignItems={"flex-end"}
        width={"100%"}
      >
        {value.map((v) => (
          <OneLineDocumentFileFieldView value={v} my={-1} />
        ))}
      </Box>
    </LabelValueForComponent>
  );
};

export const documentFileFieldConverter = ({ field, model }) => {
  return {
    ...getCommons({ field, model }),
    type: "string",
    align: "center",
    disableClickEvent: true,
    renderCell: ({ value }) => {
      return (
        value && (
          <IconButton
            LinkComponent={MuiLink}
            to={value?.file?.url}
            target="_blank"
          >
            <AttachFileIcon />
          </IconButton>
        )
      );
    },
  };
};
